var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Add--Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Add--Icon_2",
    d: "M17 12.1729H12V17.1729C12 17.7229 11.55 18.1729 11 18.1729C10.45 18.1729 10 17.7229 10 17.1729V12.1729H5C4.45 12.1729 4 11.7229 4 11.1729C4 10.6229 4.45 10.1729 5 10.1729H10V5.17285C10 4.62285 10.45 4.17285 11 4.17285C11.55 4.17285 12 4.62285 12 5.17285V10.1729H17C17.55 10.1729 18 10.6229 18 11.1729C18 11.7229 17.55 12.1729 17 12.1729Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/AddIcon.05e5c20228716dd5e07f707031d34d3a.svg";
export { ForwardRef as ReactComponent };